import React from 'react';
import { usePriceContext } from 'contracts/utils/priceContext';
import { ContractCheckbox } from './ContractFields';
import Grid from 'components/elements/Grid';
import styled from 'styled-components';

const GridWrapper = styled(Grid)`
  grid-column: 1 / -1;
`;
const PriceCheckboxes = () => {
  const {
    loadoutSelected,
    freightSelected,
    otherChargesSelected,
    carrySelected,
    warehousingSelected,
  } = usePriceContext();

  return (
    <GridWrapper>
      {loadoutSelected && (
        <ContractCheckbox
          field={loadoutSelected.field}
          checked={loadoutSelected.value}
          onChange={loadoutSelected.set}
        />
      )}

      {freightSelected && (
        <ContractCheckbox
          field={freightSelected.field}
          checked={freightSelected.value}
          onChange={freightSelected.set}
        />
      )}
      {warehousingSelected && (
        <ContractCheckbox
          field={warehousingSelected.field}
          checked={warehousingSelected.value}
          onChange={warehousingSelected.set}
        />
      )}

      {otherChargesSelected && (
        <ContractCheckbox
          field={otherChargesSelected.field}
          checked={otherChargesSelected.value}
          onChange={otherChargesSelected.set}
        />
      )}

      {carrySelected && (
        <ContractCheckbox
          field={carrySelected.field}
          checked={carrySelected.value}
          onChange={carrySelected.set}
        />
      )}
    </GridWrapper>
  );
};

export default PriceCheckboxes;
